import {useState,useEffect} from 'react'
import { useFetchData } from "../../hooks/useFetchData";
import { Button, Form, Modal } from 'react-bootstrap';
import { useMutateData } from '../../hooks/useMutateData';
import { splitStringByKeyword } from '../../utils/data/essential';
import DOMPurify from "dompurify";
const user = JSON.parse(localStorage.getItem("user"));
const UpdateComplaint = ({ show, onHide,updateData }) => {
  const [payload, setPayload] = useState(updateData)
  useEffect(()=> {
    setPayload(updateData)

  },[updateData])
  const { mutate } = useMutateData()
  const handleUpdateComplaint = async (e) => {
    e.preventDefault();
    const url = `accounts/complaints`;
    const successMessage = "Complain updated successfully";
    const keyToInvalidate = ["fetch-complaints"];
    const dataToSend = {
      ...payload,
      info: `${payload?.info} By ${user.name}`,
    };
    try {
      await mutate({
        url: url,
        payload: dataToSend,
        queryKeyToInvalidate: keyToInvalidate,
        successMessage,
        method: "PUT",
      });
      onHide();
    } catch (error) {
      console.log(error);
    }
  };
    const houseUrl = `accounts/complaints/statuses`;
    const { data: statuses } = useFetchData(
      ["fetch-complaint-status"],
      houseUrl,true,user
  );
  return (
    <div>
      <Modal
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
      >
        <Modal.Header closeButton onClick={onHide}>
          <Modal.Title>Update Complaint</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleUpdateComplaint}>
            <label className='ml-2 mt-2'>Select Status</label>
            <select
              className='form-control'
              name='statusId'
              onChange={(e) =>
                setPayload({
                  ...payload,
                  status: {
                    id: e.target.value,
                    name: e.target.options[e.target.selectedIndex].text,
                  },
                })
              }
              required
            >
              <option value={payload?.status.id}>{payload?.status.name}</option>
              {statuses?.map((status) => (
                <option key={status?.id} value={status?.id}>
                  {status?.name}
                </option>
              ))}
            </select>
            <label className='ml-2 mt-2'>Info</label>
            <textarea
              placeholder='Provide info for the complain'
              className='form-control mt-2'
              required
              name='billInfo'
              value={
                payload?.info.includes("By ")
                  ? splitStringByKeyword(payload.info, "By").before.substring(
                      0,
                      splitStringByKeyword(payload.info, "By").before.length - 2
                    )
                  : payload?.info
              }
              onChange={(e) =>
                setPayload({
                  ...payload,
                  info: DOMPurify.sanitize(e.target.value),
                })
              }
            />
            <div className='d-flex justify-content-center'>
              <Button className='custom-btn-color' type='submit'>
                SAVE
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UpdateComplaint